import { gql } from "@apollo/client";

export const GET_TERMINALS_INFO = gql`
query TerminalInfo($domain: String!) {
  terminal {
    info(domain: $domain) {
      terminal_id
      fk_locations
      fk_devices
      fk_terminal_types
      port
      fk_components
      terminal_config_id
      parent
      next
      val1_type
      val1_min
      val1_max
      val2_type
      val2_min
      val2_max
      extra
      time_act
      programmed
      sensor_p
    }
  }
}
`
export interface TerminalInfo extends WithIdentifier<Partial<BaseTerminalInfo>, "terminal_id"> {
  fk_locations?: number
  fk_devices?: number
  fk_terminal_types?: number
  port?: number
  fk_components?: number
  terminal_config_id?: number
  parent?: number
  next?: number
  sensor_p?: number
}

export interface TerminalsResponse {
  terminal: {
    info: TerminalInfo[]
  }
}

export interface BaseTerminalInfo {
  val1_type: number;
  val1_min: number;
  val1_max: number;
  val2_type: number;
  val2_min: number;
  val2_max: number;
  extra: number;
  time_act: number;
  programmed: number;
}